export function getModeId(mode, type) {
    return mode.type === type
        ? mode.id
        : undefined;
}
//# sourceMappingURL=getModeId.js.map